var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1069,
    height: 1057,
    viewBox: "0 0 1069 1057",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.683 1057L593.158 620.525L671.5 698.867L313.366 1057H156.683Z",
    fill: "#141248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1057V900.317L671.5 228.817L156.683 -286H313.367L828.183 228.817L0 1057Z",
    fill: "#141248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.32 -286H1343L906.525 150.475L828.183 72.1334L1186.32 -286Z",
    fill: "#141248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 27.3664V-129.317L671.5 542.183L1186.32 1057H1343L828.183 542.183L1343 27.3664Z",
    fill: "#141248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 900.317L984.867 542.184L1063.21 463.842L1340.2 740.836V897.519L1343 900.317Z",
    fill: "#141248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -286L514.817 228.817L436.475 307.158L0 -129.317V-286Z",
    fill: "#141248"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.d827aca6f7b1540f8cde02297ca7d909.svg";
export { ForwardRef as ReactComponent };